export enum ObjectType {
  Lesson = 'lesson',
  Task = 'task'
}
